const initialState = {
 	datos: {},
 	loading: true,
 	error: null,
 	status: null
};

 export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/account_setting/initialState.js